import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { colors, isDefaultThemeMode } from 'core/theme';

const accessibilityColors = (props) => {
  if (!isDefaultThemeMode(props)) {
    return css`
      & svg {
        & > path,
        & > polygon {
          fill: ${colors.text};
        }
      }
    `;
  }
};

export const StyledWrapper = styled.i`
  display: inline-block;
  pointer-events: none;

  & > svg {
    width: ${props => props.large ? rem(124) : rem(83)};
    height: ${props => props.large ? rem(36) : rem(24)};
  }

  ${accessibilityColors};
`;



// WEBPACK FOOTER //
// ./src/elements/Logo/styled.js